// import { Outlet, Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Layout = () => {
    return (
        <>
            {/* <nav>
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/references">references</Link>
                    </li>

                </ul>
            </nav> */}

            <Outlet />
        </>
    )
};

export default Layout;